import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import { forgotPassword, forgotPasswordSuccess, forgotPasswordFail } from '../../redux/modules/auth.module';
import { onSubmitActions } from '../../redux/saga/onSubmitActions.saga';

import ForgotPassword from './ForgotPassword.jsx';

export function mapStateToProps(state) {
  return {
    isTokenExpired: state.account.isResetTokentExpired,
    forgotError: state.account.error,
    forgotSuccess: state.account.forgotSuccess,
  };
}

const validate = (values) => {
  const errors = {};

  if (!values.email) {
    errors.email = 'Email is required';
  }

  return errors;
};

export default connect(mapStateToProps)(reduxForm({
  form: 'forgotPasswordForm',
  validate,
  onSubmit: onSubmitActions(forgotPassword, forgotPasswordSuccess, forgotPasswordFail),
})(ForgotPassword));



/** WEBPACK FOOTER **
 ** ./js/components/auth/ForgotPassword.container.js
 **/